import React from "react";
import { Routes, Route } from "react-router-dom";
import ROUTES from "./routes";

const renderRoutes = (routes) =>
  routes.map((route, index) => {
    if (route.children) {
      return (
        <Route key={index} path={route.path} element={<route.Component />}>
          {route.children.map((child, childIndex) => (
            <Route
              key={childIndex}
              path={child.path.replace("/", "")}
              element={<child.Component />}
            />
          ))}
        </Route>
      );
    }

    return (
      <Route key={index} path={route.path} element={<route.Component />} />
    );
  });

const AppRoutes = () => {
  return <Routes>{renderRoutes(ROUTES)}</Routes>;
};

export default AppRoutes;
